import { render, staticRenderFns } from "./LinhaIndustrias.vue?vue&type=template&id=22fd6dc4&scoped=true&lang=pug"
import script from "./LinhaIndustrias.vue?vue&type=script&lang=js"
export * from "./LinhaIndustrias.vue?vue&type=script&lang=js"
import style0 from "./LinhaIndustrias.styl?vue&type=style&index=0&id=22fd6dc4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd6dc4",
  null
  
)

export default component.exports